import { processDocumentWithImage, processMsoPictureData } from './utils.js';
const defaultOptions = {
    inline: false,
};
export class PictureTransformPlugin {
    constructor(options) {
        this.name = 'pictureTransform';
        this.options = { ...defaultOptions, ...options };
    }
    capabilities() {
        return {
            /**
             * 将传入的 html 中 <img> 打上 inline/block 的标记
             * 如果处于 inline 中，则分割 inline 成为两段
             */
            transformHTML: (originHTML, event) => {
                if (!(originHTML.includes('<img') || originHTML.includes('<v:imagedata'))) {
                    return originHTML;
                }
                const parser = new DOMParser();
                const doc = parser.parseFromString(originHTML, 'text/html');
                if (event) {
                    processMsoPictureData(doc, event);
                }
                if (!this.options.inline) {
                    processDocumentWithImage(doc);
                }
                return doc.documentElement.innerHTML;
            },
        };
    }
}
//# sourceMappingURL=index.js.map